import { z } from 'zod';

/**
 * 企業契約期間 新規作成フォームのバリデーションスキーマ
 *
 * - clientId / contractPlanId: Select の値は常に文字列
 * - startedOn: DatePickerFieldController が Date オブジェクトを返す
 * - endedOn: 任意。null = 無期限
 */
export const createClientContractTermFormSchema = z
  .object({
    clientId: z.string().trim().min(1, '利用企業を選択してください。'),
    contractPlanId: z.string().trim().min(1, '契約プランを選択してください。'),
    startedOn: z.date({ message: '利用開始日を入力してください。' }),
    endedOn: z.date({ message: '利用終了日を入力してください。' }).nullable().optional(),
  })
  .refine(
    data => {
      if (data.endedOn == null) return true;
      return data.endedOn >= data.startedOn;
    },
    {
      message: '利用終了日は利用開始日以降の日付を入力してください。',
      path: ['endedOn'],
    }
  );

export type CreateClientContractTermFormValues = z.infer<typeof createClientContractTermFormSchema>;
